import EditProductPage from "./ui";

export default EditProductPage;
